export default __webpack_public_path__ + "static/media/quali.ff0e258d.svg";